module.exports = __webpack_public_path__ + "02a50cac10ec0d059635022b2d154011.svg";